/**
 * Interface for StillImageBackground background images config
 */
import { Graphics} from "pixi.js";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SanEngineManager } from "./../../engine/SanEngineManager";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../SanGameConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { TextStyleConfig } from "../../translation/TextStyleConfig";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../translation/TranslationConfig";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";


export class ReelOverlay extends BaseView {

    private static _instance:ReelOverlay;
    protected _graphOverlay:Graphics;
    protected _timeline:TimelineMax;

    public static get instance():ReelOverlay{
        return this._instance;
    }

    constructor() {
        super();
        ReelOverlay._instance = this;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.REEL_OVERLAY.name).addChild(this);
    }

    public changeAlpha(alpha:number, duration:number):TimelineMax{
        this._timeline = Helper.timeLineKiller(this._timeline, new TimelineMax());
        this._timeline.to(this._graphOverlay, duration,{alpha:alpha});
        return this._timeline;
    }

    protected initAnimations():void {
        this._graphOverlay = new Graphics();
        this.addChild(this._graphOverlay);
        this._graphOverlay.alpha = 0;
    }

    public playValueText(target: PIXI.DisplayObject, val: number,waysValue:number): TimelineMax {
        const targetCont = StageManager.getLayer(SanGameConfig.instance.LAYERS.REEL_SUPER_OVERLAY.name);
        const currValue:string  = SlotGame.api.currency.formatValue(val)
        const txt: PIXI.Text | PIXI.BitmapText = targetCont.addChild(new PIXI.BitmapText(currValue, TextStyleConfig.BIT_COUNTER_WIN ));
        txt.anchor = new PIXI.Point(0.5, 0.4);
        txt.fontSize = 18;

        const txtWays = targetCont.addChild(new PIXI.Text(""));
        txtWays.style = TextStyleConfig.XWAYS_WIN2;
        txtWays.anchor.set(0.5, 0.4);
        txtWays.pivot.y = -60;
        txtWays.text = waysValue.toString() + " " +  Translation.translate(Translation.translate((val == 1 ? TranslationConfig.WAY_WON : TranslationConfig.WAYS_WON)));
        txtWays.updateTransform();
        txtWays.scale.set(0.4)

        txt.zIndex = 5000;
        this.sortChildren();

        let startPos: PIXI.Point = Helper.copyLocalPosition(txt, target)
        // startPos = MathHelper.pointSub(startPos,this.position);
        const heightYDirr: number = 60;

        txt.alpha = 0;
        txtWays.alpha = 0;
      
        txt.position = startPos;
        txtWays.position = startPos;

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 1.2;
        const scaleDurr: number = 0.3;
        const alphaDurr: number = 0.25;
        TimelineMax
        const tl: TimelineMax = new TimelineMax({
            onComplete: () => { 
                if(txt && txt.transform) txt.destroy({ children: true });
                if(txtWays && txtWays.transform) txtWays.destroy({ children: true });
            }
        });

        const animate:PIXI.DisplayObject[] = [txt,txtWays];

        tl.to(animate, alphaDurr, { alpha: 1,  ease: "Power3.easeIn" }, 0);
        tl.to(animate,moveDurr*0.75, { y: up, }, 0);
        animate.forEach(item => {
            tl.fromTo(item.scale,scaleDurr, { x: 0.35, y: 0.35 }, { x: 1, y: 1, }, 0);
        })
        tl.to(animate,alphaDurr, {  alpha: 0 }, "-="+alphaDurr)
        return tl;
    }

    protected RePaint():void{
        const w:number = (SymbolData.DEFAULT_SYMBOL.DIM.WIDTH + 4)*SanEngineManager.dim.scale.x;
        const h:number = SymbolData.DEFAULT_SYMBOL.DIM.HEIGHT * SanEngineManager.dim.scale.y;
        this._graphOverlay.clear();
        this._graphOverlay.beginFill(0x000000, 1);
        this._graphOverlay.drawRect(-w*0.5,-h*0.5,w*5,h*3);
        this._graphOverlay.endFill();
    }

    protected onResize():void{
        this.position  = SanEngineManager.getReelPos(0);
        this.RePaint();
    }
}